import React, {
  createContext,
  Dispatch,
  PropsWithChildren,
  ReactElement,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';

export type ThemeValues = 'light' | 'dark';

type PassedThemeProps = [ThemeValues, Dispatch<SetStateAction<ThemeValues>>];

const ThemeContext = createContext<PassedThemeProps | undefined>(undefined);

export function useTheme(): PassedThemeProps {
  const context = useContext(ThemeContext);

  if (!context) {
    throw new Error('themeContext must be used inside a ThemeProvider');
  }

  return context;
}

export function ThemeProvider({
  children,
}: PropsWithChildren<unknown>): ReactElement {
  const [theme, setTheme] = useState<ThemeValues>('dark');

  useEffect(() => {
    document.body.dataset.theme = theme;
  }, [theme]);

  return (
    <ThemeContext.Provider value={[theme, setTheme]}>
      {children}
    </ThemeContext.Provider>
  );
}
